import z from "zod";

export const Schema = z.object({
  totalEvents: z.number(),
  upcomingEvents: z.number(),
  totalTicketsSold: z.number(),
  totalTicketsCap: z.number(),
  totalRevenue: z.number(),
  avgFillRate: z.number(),
  byStatus: z.object({
    AVAILABLE: z.number(),
    LOCKED: z.number(),
    FINISHED: z.number(),
    CANCELED: z.number()
  })
});

export type Type = z.infer<typeof Schema>;
